<section class="container-fluid landing-container">
    <landing-page></landing-page>
    <page-embed *ngIf="!authenticated" [marketingPageId]="'landing-ad'"></page-embed>

    <div class="section-disclaimer" *ngIf="showBaoying">
        <h5 translate="cart.landing.disclaimer.title"></h5>
        <p translate="cart.landing.disclaimer.line.1"></p>
        <p translate="cart.landing.disclaimer.line.2"></p>
        <p translate="cart.landing.disclaimer.line.3"></p>
        <p translate="cart.landing.disclaimer.line.4"></p>
    </div>
</section>
